import React, { useEffect, useState } from 'react';
import { Navbar, Container, Nav } from 'react-bootstrap';
import { Sun, Moon, Lock } from 'react-bootstrap-icons';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import { useTheme } from '../../../contexts/ThemeContext';
import logo from '../../../assets/images/logo 512.png';
import './Navbar.css';
import LoginModal from '../../common/loginModal/LoginModal';
import CartBadge from '../../common/cart/cartBadge/CartBadge';
import { useAuth } from '../../../contexts/AuthContext';

const MyNavbar: React.FC = () => {
  const { isDarkMode, toggleTheme } = useTheme();
  const { pathname } = useLocation();
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const { isAuthenticated, user, logout } = useAuth();
  const navigate = useNavigate();

  const navItems = [
    { path: '/servizi', label: 'Servizi offerti' },
    { path: '/rimettiti-al-centro', label: 'Rimettiti al centro' },
    { path: '/in-regalo', label: 'In regalo' },
    { path: '/chi-sono', label: 'Chi sono' },
  ];

  const closeMenu = () => setExpanded(false);

  useEffect(() => {
    closeMenu();
  }, [pathname]);

  return (
    <>
      <Navbar
        bg={isDarkMode ? 'dark' : 'light'}
        variant={isDarkMode ? 'dark' : 'light'}
        expand="lg"
        expanded={expanded}
        onToggle={(nextExpanded) => setExpanded(nextExpanded)}
        className="custom-navbar"
        fixed="top"
      >
        <Container>
          <Navbar.Brand
            as={Link}
            to="/"
            className="navbar-brand-custom"
            onClick={closeMenu}
          >
            <img
              src={logo}
              alt="Benessere Posturale Logo"
              height="40"
              className="d-inline-block align-top me-2"
            />
            <span className="brand-text">Benessere Posturale</span>
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="basic-navbar-nav" />

          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto" activeKey={pathname}>
              {navItems.map((item) => (
                <Nav.Link
                  key={item.path}
                  as={Link}
                  to={item.path}
                  eventKey={item.path}
                  className="nav-link-custom"
                  onClick={closeMenu}
                >
                  {item.label}
                </Nav.Link>
              ))}
            </Nav>

            <div className="theme-toggle-container">
              <CartBadge onClick={closeMenu} />

              <Nav.Link
                className="lock-icon-container me-3"
                onClick={() => {
                  closeMenu();

                  if (isAuthenticated && user) {
                    const roleRedirect: Record<string, string> = {
                      superadmin: '/superadmin',
                      admin: '/admin',
                      user: '/dashboard',
                    };
                    navigate(roleRedirect[user.role] ?? '/dashboard');
                  } else {
                    setShowLoginModal(true);
                  }
                }}
                aria-label={
                  isAuthenticated ? 'Vai alla tua area' : 'Area riservata'
                }
                title={isAuthenticated ? 'Vai alla tua area' : 'Area riservata'}
              >
                <Lock
                  size={22}
                  className={`lock-icon ${isDarkMode ? 'text-light' : 'text-dark'}`}
                />
              </Nav.Link>
              {/* Logout — solo se loggato */}
              {isAuthenticated && (
                <Nav.Link
                  className="me-2"
                  onClick={() => {
                    closeMenu();
                    logout();
                  }}
                  title="Esci"
                  aria-label="Esci dall'account"
                >
                  <i
                    className={`bi bi-box-arrow-right fs-5 ${isDarkMode ? 'text-light' : 'text-dark'}`}
                  />
                </Nav.Link>
              )}

              <button
                onClick={toggleTheme}
                className="theme-toggle-btn"
                aria-label={`Passa a modalità ${isDarkMode ? 'chiara' : 'scura'}`}
                aria-checked={isDarkMode}
                role="switch"
              >
                {isDarkMode ? (
                  <span>
                    <Sun size={20} className="theme-icon" />
                  </span>
                ) : (
                  <span>
                    <Moon size={20} className="theme-icon" />
                  </span>
                )}
              </button>
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <LoginModal
        show={showLoginModal}
        onHide={() => setShowLoginModal(false)}
        disableRedirect={true}
        onLoginSuccess={(loggedUser) => {
          if (!loggedUser) return;

          closeMenu();

          const roleRedirect: Record<string, string> = {
            superadmin: '/superadmin',
            admin: '/admin',
            user: '/dashboard',
          };

          navigate(roleRedirect[loggedUser.role] ?? '/dashboard');
        }}
      />
    </>
  );
};

export default MyNavbar;
